import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'username',
})
export class UsernamePipe implements PipeTransform {
  transform(email: string): string {
    if (!email) return ''
    const atIndex = email.indexOf('@')
    return atIndex > 0 ? email.substring(0, atIndex) : email
  }
}
